import React from "react";
import { default as RModal } from "react-modal";
import "./style.scss";
RModal.setAppElement("#root");

export const Modal = ({ onClose, isOpen, title, children, className }) => {
  return (
    <RModal
      isOpen={isOpen}
      contentLabel="add Modal"
      portalClassName="full_screen_modal"
      className={`modal_parent ${className || "-"}`}
    >
      <div className="modal_component">
        <div className="modal-header">
          <p className="title">{title}</p>
          <button className="close_btn" onClick={onClose}>
            &#10005;
          </button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </RModal>
  );
};
